import flattenIndicatorOutputsForTable from './flattenIndicatorOutputsForTable';

/** Maps `add_indicator` API payload to dimensional data-table row shape (V2 outputs / grid). */
export default function mapAddIndicatorResponseToDimensionalRow(
  raw: Record<string, any>,
  indicatorHeaders: { name: string }[],
) {
  const format = raw.data_format ?? raw.format ?? 'Number';
  const indicatorType = raw.indicator_type ?? raw.type ?? 'input';

  return {
    id: raw.id,
    name: raw.name ?? '',
    help: raw.help ?? '',
    type: format,
    format,
    format_properties: raw.data_format_properties ??
      raw.format_properties ?? {
        scale: null,
        measure: null,
        null_value: '',
        decimal_points: 2,
        thousand_separators: true,
        negative_parentheses: false,
      },
    chart_type: raw.chart_type ?? 'line',
    dims: raw.dims ?? null,
    output_format: raw.output_format ?? 'default',
    is_default_KPI: Boolean(raw.is_default_KPI),
    formula: raw.formula ?? null,
    calculated_formula: raw.calculated_formula ?? null,
    data_type: raw.data_type ?? 'Number',
    is_favourite: raw.favourite !== undefined ? Boolean(raw.favourite) : Boolean(raw.is_favourite),
    indicator_type: typeof indicatorType === 'string' ? indicatorType.toLowerCase() : 'input',
    data_input: {
      dimensions: [],
      block_id: raw.block_id,
      time_dim: raw.time_dim,
    },
    warning: raw.warning ?? [],
    time_granularity: raw.time_granularity ?? null,
    total_values:
      raw.total_values?.length > 0
        ? raw.total_values
        : indicatorHeaders.map((header) => ({
            name: header.name,
            value: 0,
          })),
    total: raw.total ?? 0,
    dim_item_data: raw.dim_item_data ?? null,
  };
}

/** Parent row + chevron children when `dim_item_data` is on the mapped parent row. */
export function mapAndFlattenAddIndicatorToDimensionalRows(
  raw: Record<string, any>,
  indicatorHeaders: { name: string }[],
): any[] {
  const parent = mapAddIndicatorResponseToDimensionalRow(raw, indicatorHeaders);
  return flattenIndicatorOutputsForTable(parent);
}
